// extracted by mini-css-extract-plugin
export default {"login":"MfcC1P","logOutText":"rp4XSc"};